import React from "react";
import { postRequest } from "./QuoteApiService";

export const getQuotesSearch = (rec, existingParams) => {
  return new Promise((resolve, reject) => {
    try {
      // do an SDK, DB call or API endpoint axios call here and return the promise.

      postRequest(`getQuotesSearch?${existingParams.toString()}`, rec)
      .then((res) => {
        console.log("getQuotesSearch > axios res=", res);
        //const persons = res.data;
        resolve(res.data);
      })
      .catch((err) => {
        console.log("getQuotesSearch > axios err=", err);
        reject("Error in getQuotesSearch axios!");
      });
    } catch (error) {
      console.error("in services > getQuotesSearch, Err===", error);
      //reject(SYSTEM_ERROR);
    }
  });
  
}